import * as React from 'react';

import { SiteInsightsLinkPosition } from '@gitbook/api-client';
import { ButtonSkeleton, Description, FieldGroup, Label } from '@gitbook/spine-react';

import { ContentReferenceInput } from '../../../ContentReferences';
import { SiteInsightsLinkUsageButton } from '../../../SiteInsights';
import type { SitesCustomizationPanelProps } from '../../types';

/**
 * Settings to configure the message for the site announcement
 */
export function AnnouncementLinkSettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;

    return (
        <FieldGroup orientation="vertical">
            <Label>Link</Label>
            <Description>Where to send visitors when they click the banner.</Description>
            <div className="flex flex-row gap-2">
                <div className="flex-1">
                    <ContentReferenceInput
                        placeholder="Search for a page type an URL..."
                        value={settings.announcement?.link?.to ?? null}
                        onChange={(value) =>
                            setSettings((prev) => ({
                                ...prev,
                                announcement: {
                                    enabled: true,
                                    message: '',
                                    style: 'info',
                                    ...prev.announcement,
                                    link: value
                                        ? {
                                              title: prev.title ?? '',
                                              to: value,
                                          }
                                        : undefined,
                                },
                            }))
                        }
                        size="medium"
                        clearable={true}
                    />
                </div>

                {settings.announcement?.link?.to ? (
                    <React.Suspense
                        fallback={<ButtonSkeleton size="medium" iconOnly label="Usage" />}
                    >
                        <SiteInsightsLinkUsageButton
                            size="medium"
                            kind="secondary"
                            iconOnly
                            link={{
                                site: props.site,
                                organizationId: props.organizationId,
                                contentRef: settings.announcement.link.to,
                                position: SiteInsightsLinkPosition.Announcement,
                            }}
                        />
                    </React.Suspense>
                ) : null}
            </div>
        </FieldGroup>
    );
}
